import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from 'react';
import Approvalauthority from './Approvalauthority';
import { DataContext } from '../context/DataProvider';
import { FaChevronDown } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import CodeMozoee from './ChapterCodeMozoee';

const SearchableDropDownCodeMozoee = () => {
  const { titleSubInfo, setTitleSubInfo, pIdChapter, setPIdChapter } =
    useContext(DataContext);
  // const [searchText, setSearchText] = useState('خانواده');
  const [searchText, setSearchText] = useState('');
  // const [clickText, setclickText] = useState(titSubParentID?.Parent_ID);
  // const [clickText, setclickText] = useState('');
  const [clickText, setclickText] = useState('خانواده');
  const [pageNumber, setPageNumebr] = useState(1);
  const [metheod, setMetheod] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const observe = useRef();
  const { loading, error, hasMore, subjectsArray } = CodeMozoee(
    searchText,
    metheod,
  );

  // console.log('subjectArrayCodeMozoee', subjectsArray);
  // useEffect(() => {
  //   const parentId = Array.from(subjectsArray)
  //     .filter((i) => i.value == titleSubInfo.Parent_ID)
  //     .map((item) => item.label);

  //   // console.log('parentId', parentId);
  //   setclickText(parentId);

  //   return () => {};
  // }, [titleSubInfo]);

  const handelChange = (e) => {
    setSearchText(e.target.value);
    setclickText(e.target.value);
    setPageNumebr(1);
  };
  const handleonClick = () => {
    setOpenMenu(!openMenu);
  };
  // console.log()
  const lastorgElement = useCallback(
    (node) => {
      if (loading) return;
      if (observe.current) observe.current.disconnect();
      observe.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumebr((prevPageNumber) => prevPageNumber + 1);
          // console.log("visiable");
        }
      });
      //   if (node) observer.current
      //   console.log(node);
      if (node) observe.current.observe(node);
    },
    [loading, hasMore],
  );
  const handleClick = (item: {}) => {
    // console.log('item', item);

    setPIdChapter(() => item.value);

    // setTitleSubInfo((caseData) => ({
    //   ...caseData,
    //   Parent_ID: item.value,
    // }));
    // setTitSubParentID(item.value);
    setclickText(item.label);
    setOpenMenu(false);
  };
  const emptyInput = (e) => {
    e.preventDefault();
    setclickText('');
    setPIdChapter(null);

    // setTitleSubInfo((caseData) => ({
    //   ...caseData,
    //   Parent_ID: null,
    // }));
    // setTitSubParentID('');
  };
  return (
    <div className="w-full flex flex-col z-99999">
      <div className="relative ltr py-1  flex items-center">
        <input
          className="border text-[14px] border-gray-200 p-2 absolute rounded-md w-full focus:outline-none text-right "
          placeholder="...جستجوی کدموضوعی"
          // placeholder="...جستجوی کدموضوعی"
          // placeholder=`${titleSubInfo.Parent_ID}`
          onChange={handelChange}
          onClick={handleonClick}
          // value={clickText}
          value={clickText}
        />
        <div className="absolute  flex items-center justify-center py-3/1 rounded-md px-2">
          {clickText === '' ? (
            <>
              <button className=" ltr mr-2  text-center">
                <FaChevronDown className="text-[12px] text-gray-400" />
              </button>
              <div className="text-gray-400">|</div>
            </>
          ) : (
            <>
              <button className="" onClick={emptyInput}>
                <IoIosClose className="text-[20px] text-gray-400" />
              </button>
            </>
          )}
        </div>
        {/* <div className=""><FaChevronDown /></div> */}
      </div>
      {openMenu && (
        <div className="w-[70%] bg-[#ffffff] absolute z-5  h-60 border rounded-md mt-6  overflow-y-auto">
          {Array.from(subjectsArray).map((i, index) => {
            if (Array.from(subjectsArray).length === index + 1) {
              return (
                <div
                  onClick={() => handleClick(i)}
                  ref={lastorgElement}
                  key={i.value}
                  className="cursor-pointer hover:bg-blue-100 py-2 px-1"
                >
                  {i.label}
                </div>
              );
            } else {
              return (
                <div
                  onClick={() => handleClick(i)}
                  className="cursor-pointer hover:bg-blue-100 py-2 px-1"
                  key={i.value}
                >
                  {i.label}
                </div>
              );
            }
          })}
          <div>{loading && 'loading...'}</div>
          {/* {error && <div>error...</div>} */}
        </div>
      )}
    </div>
  );
};

export default SearchableDropDownCodeMozoee;
